export interface BuildingPropertyField {
    type: "string" | "number" | "select";
    key: string;
    canEdit: boolean;
    required?: boolean;
    allowNegativeNumber?: boolean;
}

export const overviewFieldValues: BuildingPropertyField[] = [
    {
        type: "string",
        key: "city",
        canEdit: false,
    },
    {
        type: "string",
        key: "stateProvince",
        canEdit: false,
    },
    {
        type: "string",
        key: "climateZone",
        canEdit: false,
    },
    {
        type: "select",
        key: "buildingArchetype",
        canEdit: true,
        required: true,
    },
    {
        type: "number",
        key: "yearBuiltOriginal",
        canEdit: true,
        required: true,
        allowNegativeNumber: false,
    },
];

export const floorFieldValues: BuildingPropertyField[] = [
    {
        type: "number",
        key: "grossFloorArea",
        canEdit: true,
    },
    {
        type: "number",
        key: "floorsAboveGrade",
        canEdit: true,
    },
    {
        type: "number",
        key: "ledInstalledRatio",
        canEdit: true,
        required: false,
    },
];

export const roofFieldValues: BuildingPropertyField[] = [
    {
        type: "number",
        key: "roofInstallationYear",
        canEdit: false,
    },
    {
        type: "number",
        key: "availableRoofAreaRatio",
        canEdit: true,
        required: false,
    },
    {
        type: "number",
        key: "roofArea",
        canEdit: false,
    },
    {
        type: "number",
        key: "roofRValue",
        canEdit: false,
    },
];

export const windowFieldValues: BuildingPropertyField[] = [
    {
        type: "number",
        key: "windowInstallationYear",
        canEdit: false,
    },
    {
        type: "number",
        key: "windowRValue",
        canEdit: false,
    },
    {
        type: "number",
        key: "windowSolarHeatGainCoefficient",
        canEdit: false,
    },
    {
        type: "number",
        key: "windowToWallRatio",
        canEdit: false,
    },
];

export interface BuildingSectionProps {
    location?: Location;
    buildingUid: string;
    buildingConstruction: BuildingModelConstruction;
    setProperties: (properties: Partial<BuildingProperties>) => void;
    isEditing: boolean;
    buildingFootprints?: BuildingFootprints;
    selectedFootprintUid?: string;
    updateValidationMapForKey: (key: string, value: boolean) => void;
    selectedFootprintPolygon?: FootprintPolygon;
    setSelectedFootprintPolygon?: React.Dispatch<React.SetStateAction<FootprintPolygon | undefined>>;
}
